import { logWarning } from './Logger';

let chargebeePromise: Promise<void> | null = null;

export function loadChargebeeScript(): Promise<void> {
  if (window.Chargebee) return Promise.resolve();

  if (!chargebeePromise) {
    chargebeePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://js.chargebee.com/v2/chargebee.js';
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.onload = () => resolve();
      script.onerror = () => {
        chargebeePromise = null;
        script.remove();
        logWarning('Failed to load Chargebee script');
        reject(new Error('Failed to load Chargebee'));
      };
      document.head.appendChild(script);
    });
  }

  return chargebeePromise;
}
